<template>
  <StateDropdownSelectClassification
    outline
    :value="state"
    :menu="items"
    :placeholder="'全部'"
    :all-select-text="'全部'"
    class="w-full"
  />
</template>

<script>
export default {
  data() {
    return {
      state: [],
      items: [
        {
          title: "環保",
          value: 4,
          menu: [
            { text: "空氣污染防制", value: 14 },
            { text: "水污染防治", value: 15 },
            { text: "廢棄物清理", value: 16 },
            { text: "噪音污染管制", value: 17 },
            { text: "土壤及地下水防治", value: 18 },
            { text: "毒性及關注化學物質管理", value: 19 },
          ],
        },
        {
          title: "生產安全",
          value: 7,
          menu: [
            { text: "建築及消防安全管理", value: 23 },
            { text: "毒化物管理", value: 24 },
          ],
        },
        {
          title: "勞工及職業病",
          value: 6,
          menu: [
            { text: "勞動關係管理", value: 21 },
            { text: "職業安全衛生", value: 22 },
          ],
        },
        {
          title: "專門領域",
          value: 5,
          menu: [{ text: "食品安全衛生", value: 20 }],
        },
        {
          title: "通用領域",
          value: 10,
          menu: [
            { text: "通用領域", value: 26 },
            { text: "20220215測試新增子領域", value: 28 },
          ],
        },
      ],
    }
  }
}
</script>

<style>

</style>